import { Injectable } from '@angular/core';
import { SettingsService } from './settings.service';
import { StorageManagerService } from './storage-manager.service';

@Injectable()
export class HCSplValidationService {
    constructor(private settingsService: SettingsService, private storageManagerService: StorageManagerService) { 
    }

    // Page status
    public readonly PAGE_STATE_UPLOADING = 'Loading';
    public readonly PAGE_STATE_READY = 'Ready';
 
    getFileUploadUrl(): string {
        const settings = this.settingsService.getSettings();
        const apiUrl = settings.ApiGatewayUrl;
        const action = `ssdpds/v1/HealthCanada/Validate`;
        return `${apiUrl}/${action}`;
    }    
}
